export default {
  '用户列表':'User List',
  '添加':'Add',
  '序号':'No.',
  '用户ID':'ID',
  '状态':'State',
  '启用':'Enable',
  '禁用':'Disable',
  '操作':'Operations',
  '创建时间':'Create Date',
  '删除成功':'Successfully Deleted',
  '编辑':'Edit',
  '用户信息':'User Information',
  '用户状态：':'User Status:',
  '模块权限分配':'Permission',
  '请输入姓名':'Please enter your name',
  '请输入电话':'Please enter a phone number',
  '请输入合法手机号/电话号':'Please enter a valid phone number',
  '接口错误':'Interface Error',
  '授权分配成功':'Authorization assigned successfully',
  '授权禁止成功':'Authorization prohibited successfully',
  '操作失败，请重试':'Operation failed, please try again',
  '操作成功':'Operation Successful',
  '操作失败':'Operation Failed',
  '姓名':'Name',
  '请输入':'Please Enter'
}